var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-regional-screen" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", {
        staticClass: "screen-name zhenyan-node",
        domProps: { textContent: _vm._s(_vm.info.name) }
      }),
      _c("div", { staticClass: "header-right" }, [
        _c("div", { staticClass: "time-box" }, [
          _c("div", {
            staticClass: "time zhenyan-node",
            domProps: { textContent: _vm._s(_vm.time) }
          }),
          _c("div", { staticClass: "day" }, [
            _c("b", {
              staticClass: "date",
              domProps: { textContent: _vm._s(_vm.date) }
            }),
            _c("b", { domProps: { textContent: _vm._s(_vm.day) } })
          ])
        ]),
        _c("div", { staticClass: "weather-box" }, [
          _c("img", {
            attrs: {
              src:
                _vm.ossHost +
                "file/weather/" +
                (_vm.weatherInfo.code || 1) +
                "@2x.png",
              alt: ""
            }
          }),
          _c("div", {
            staticClass: "city-name",
            domProps: { textContent: _vm._s(_vm.info.city) }
          }),
          _c("div", { staticClass: "tem" }, [
            _c("b", {
              domProps: { textContent: _vm._s(_vm.weatherInfo.temperature) }
            }),
            _vm._v("°C")
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "content-top" }, [
        _c("div", { staticClass: "regional-info" }, [
          _c("div", { staticClass: "info-box" }, [
            _vm._m(0),
            _c("div", { staticClass: "info-item1" }, [
              _c("div", { staticClass: "item-box first-child" }, [
                _c("img", {
                  attrs: { src: _vm.ossHost + "img/gov_icon5.png", alt: "" }
                }),
                _c("div", { staticClass: "item-count-box" }, [
                  _c(
                    "b",
                    { staticClass: "item-count zhenyan-node" },
                    [
                      _c("animate-number", {
                        key: _vm.info.totalUserCount,
                        ref: "totalUserCount",
                        attrs: {
                          from: "0",
                          to: _vm.info.totalUserCount,
                          duration: _vm.duration,
                          easing: "easeOutQuad"
                        }
                      })
                    ],
                    1
                  ),
                  _c("b", [_vm._v("人")])
                ]),
                _c("div", { staticClass: "item-text" }, [_vm._v("总用户数")])
              ]),
              _c("div", { staticClass: "item-box" }, [
                _c("img", {
                  attrs: { src: _vm.ossHost + "img/gov_icon4.png", alt: "" }
                }),
                _c("div", { staticClass: "item-count-box" }, [
                  _c(
                    "b",
                    { staticClass: "item-count zhenyan-node" },
                    [
                      _c("animate-number", {
                        key: _vm.info.totalPoolCount,
                        ref: "totalPoolCount",
                        attrs: {
                          from: "0",
                          to: _vm.info.totalPoolCount,
                          duration: _vm.duration,
                          easing: "easeOutQuad"
                        }
                      })
                    ],
                    1
                  ),
                  _c("b", [_vm._v("个")])
                ]),
                _c("div", { staticClass: "item-text" }, [_vm._v("总鱼塘数")])
              ])
            ]),
            _c("div", { staticClass: "info-item2" }, [
              _c("div", { staticClass: "item-box first-child" }, [
                _c("img", {
                  attrs: { src: _vm.ossHost + "img/gov_icon7.png", alt: "" }
                }),
                _c("div", { staticClass: "item-count-box" }, [
                  _c(
                    "b",
                    { staticClass: "item-count zhenyan-node" },
                    [
                      _c("animate-number", {
                        key: _vm.info.totalPoolAcreage,
                        ref: "totalPoolAcreage",
                        attrs: {
                          from: "0",
                          to: _vm.info.totalPoolAcreage,
                          duration: _vm.duration,
                          easing: "easeOutQuad"
                        }
                      })
                    ],
                    1
                  ),
                  _c("b", [_vm._v("亩")])
                ]),
                _c("div", { staticClass: "item-text" }, [_vm._v("鱼塘总面积")])
              ]),
              _c("div", { staticClass: "item-box" }, [
                _c("img", {
                  attrs: { src: _vm.ossHost + "img/gov_icon6.png", alt: "" }
                }),
                _c("div", { staticClass: "item-count-box" }, [
                  _c(
                    "b",
                    { staticClass: "item-count zhenyan-node" },
                    [
                      _c("animate-number", {
                        key: _vm.warningInfo.totalOnlineCount,
                        ref: "totalOnlineNum",
                        attrs: {
                          from: "0",
                          to: _vm.warningInfo.totalOnlineCount,
                          duration: _vm.duration,
                          easing: "easeOutQuad"
                        }
                      })
                    ],
                    1
                  ),
                  _c("b", [_vm._v("台")])
                ]),
                _c("div", { staticClass: "item-text" }, [_vm._v("在线设备数")])
              ])
            ]),
            _vm._m(1)
          ])
        ]),
        _c("div", { staticClass: "pond-info" }, [
          _c("div", { staticClass: "info-box" }, [
            _vm._m(2),
            _c("div", { staticClass: "pond-info-item" }, [
              _c("div", { staticClass: "item-title" }, [_vm._v("鱼塘溶氧")]),
              _c("div", { staticClass: "item-text" }, [
                _vm._v("溶氧正常 "),
                _c(
                  "b",
                  { staticClass: "zhenyan-node" },
                  [
                    _c("animate-number", {
                      key: _vm.warningInfo.oxyFormalCount,
                      ref: "ryOnlineCount",
                      attrs: {
                        from: "0",
                        to: _vm.warningInfo.oxyFormalCount,
                        duration: _vm.duration,
                        easing: "easeOutQuad"
                      }
                    })
                  ],
                  1
                ),
                _c("b", [_vm._v("个")])
              ]),
              _c("div", { staticClass: "item-text ry-text" }, [
                _vm._v("溶氧过低 "),
                _c(
                  "b",
                  { staticClass: "zhenyan-node" },
                  [
                    _c("animate-number", {
                      key: _vm.warningInfo.lowDissolvedOxygenCount,
                      ref: "lowDissolvedOxygenCount",
                      attrs: {
                        from: "0",
                        to: _vm.warningInfo.lowDissolvedOxygenCount,
                        duration: _vm.duration,
                        easing: "easeOutQuad"
                      }
                    })
                  ],
                  1
                ),
                _c("b", [_vm._v("个")])
              ])
            ]),
            _c("div", { staticClass: "pond-info-item pond-device-item" }, [
              _c("div", { staticClass: "item-title" }, [_vm._v("设备")]),
              _c("div", { staticClass: "item-text" }, [
                _vm._v("正常 "),
                _c(
                  "b",
                  { staticClass: "zhenyan-node" },
                  [
                    _c("animate-number", {
                      key: _vm.warningInfo.totalFormalCount,
                      ref: "totalFormalCount",
                      attrs: {
                        from: "0",
                        to: _vm.warningInfo.totalFormalCount,
                        duration: _vm.duration,
                        easing: "easeOutQuad"
                      }
                    })
                  ],
                  1
                ),
                _c("b", [_vm._v("台")])
              ]),
              _c("div", { staticClass: "item-text device-text" }, [
                _vm._v("报警台数 "),
                _c(
                  "b",
                  { staticClass: "zhenyan-node" },
                  [
                    _c("animate-number", {
                      key: _vm.warningInfo.warnCount,
                      ref: "warnCount",
                      attrs: {
                        from: "0",
                        to: _vm.warningInfo.warnCount,
                        duration: _vm.duration,
                        easing: "easeOutQuad"
                      }
                    })
                  ],
                  1
                ),
                _c("b", [_vm._v("台")])
              ]),
              _c("div", { staticClass: "line" })
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "content-bottom" }, [
        _c("div", { staticClass: "canvas-box bottom-box" }, [
          _c("div", { attrs: { id: "map-box" } }),
          _c("div", { staticClass: "user-box" }, [
            _c("img", {
              attrs: { src: _vm.ossHost + "img/user-border.png", alt: "" }
            }),
            _c("div", { staticClass: "user-content" }, [
              _c("div", { staticClass: "header" }, [
                !_vm.userInfo.headImg
                  ? _c("img", {
                      attrs: {
                        src: _vm.ossHost + "img/default_avatar.png",
                        alt: ""
                      }
                    })
                  : _c("img", {
                      attrs: { src: _vm.userInfo.headImg, alt: "" }
                    }),
                _c("div", {
                  staticClass: "user-name",
                  domProps: { textContent: _vm._s(_vm.userInfo.name || "XX") }
                }),
                _c("div", {
                  staticClass: "user-phone",
                  domProps: { textContent: _vm._s(_vm.userInfo.phone) }
                })
              ]),
              _c("div", { staticClass: "fish-type fish-type-item" }, [
                _vm._v("养殖品种："),
                _c("b", {
                  domProps: {
                    textContent: _vm._s(_vm.userInfo.fishTypesText || "混养")
                  }
                })
              ]),
              _c("div", { staticClass: "fish-type" }, [
                _vm._v("鱼塘数："),
                _c("b", [_vm._v(_vm._s(_vm.userInfo.poolCount || 1) + "个")])
              ]),
              _c("div", { staticClass: "fish-type" }, [
                _vm._v("设备数："),
                _c("b", [_vm._v(_vm._s(_vm.userInfo.deviceCount || 5) + "台")])
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "swiper-box bottom-box" }, [
          _c(
            "div",
            {
              staticClass: "swiper-item-box",
              style: { marginLeft: "-" + _vm.pondTabIndex * 100 + "%" }
            },
            _vm._l(_vm.pondList, function(pondInfo, index) {
              return _c("div", { key: index, staticClass: "item-box" }, [
                _c("div", { staticClass: "kzq-top-chart" }, [
                  _c("div", { staticClass: "box-left" }, [
                    _c("div", {
                      staticClass: "pond-name",
                      domProps: { textContent: _vm._s(pondInfo.poolName) }
                    }),
                    _c("div", { staticClass: "pond-controller-box" }, [
                      _c("div", { staticClass: "controller-item" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.ossHost + "img/gov_icon3.png",
                            alt: ""
                          }
                        }),
                        _c("div", { staticClass: "controller-count" }, [
                          _c(
                            "b",
                            { staticClass: "count zhenyan-node" },
                            [
                              _c("animate-number", {
                                key: pondInfo.serverOpenTimes,
                                ref: "serverOpenTimes",
                                refInFor: true,
                                attrs: {
                                  from: "0",
                                  to: pondInfo.serverOpenTimes,
                                  duration: _vm.duration,
                                  easing: "easeOutQuad"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v("次 ")
                        ]),
                        _c("div", { staticClass: "item-text" }, [
                          _vm._v("远程开关")
                        ])
                      ]),
                      _c("div", { staticClass: "controller-item" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.ossHost + "img/gov_icon2.png",
                            alt: ""
                          }
                        }),
                        _c("div", { staticClass: "controller-count" }, [
                          _c(
                            "b",
                            { staticClass: "count zhenyan-node" },
                            [
                              _c("animate-number", {
                                key: pondInfo.timingOpenTimes,
                                ref: "timingOpenTimes",
                                refInFor: true,
                                attrs: {
                                  from: "0",
                                  to: pondInfo.timingOpenTimes,
                                  duration: _vm.duration,
                                  easing: "easeOutQuad"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v("次 ")
                        ]),
                        _c("div", { staticClass: "item-text" }, [
                          _vm._v("定时开关")
                        ])
                      ]),
                      _c("div", { staticClass: "controller-item" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.ossHost + "img/gov_icon1.png",
                            alt: ""
                          }
                        }),
                        _c("div", { staticClass: "controller-count" }, [
                          _c(
                            "b",
                            { staticClass: "count zhenyan-node" },
                            [
                              _c("animate-number", {
                                key: pondInfo.lowOxygenCount,
                                ref: "lowOxygenCount",
                                refInFor: true,
                                attrs: {
                                  from: "0",
                                  to: pondInfo.lowOxygenCount,
                                  duration: _vm.duration,
                                  easing: "easeOutQuad"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v("次 ")
                        ]),
                        _c("div", { staticClass: "item-text" }, [
                          _vm._v("低氧告警")
                        ])
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "box-right" }, [
                    _c("div", { staticClass: "ry-info-box" }, [
                      _c("div", { staticClass: "label" }, [_vm._v("当前")]),
                      _c("div", { staticClass: "ry-val oxy-val" }, [
                        _vm._v(_vm._s(pondInfo.ryLineView.oxygen || "-") + " "),
                        _c("b", [_vm._v("mg/L")])
                      ]),
                      _c("div", { staticClass: "ry-val" }, [
                        _vm._v(_vm._s(pondInfo.ryLineView.temperature || "-")),
                        _c("b", [_vm._v("°C")])
                      ])
                    ]),
                    _c("div", { staticClass: "power-chart-box" }, [
                      _c("div", { staticClass: "chart-title" }, [
                        _vm._v("月度用电量")
                      ]),
                      _c("div", {
                        staticClass: "power-chart-canvas",
                        attrs: { id: "power-chart-box" + index }
                      })
                    ])
                  ])
                ]),
                _c("div", { staticClass: "ry-bottom-chart-box" }, [
                  _c("div", { staticClass: "ry-chart-box" }, [
                    _c("div", { staticClass: "chart-title" }, [_vm._v("溶氧")]),
                    _c("div", {
                      staticClass: "ry-chart-canvas",
                      attrs: { id: "ry-chart-box" + index }
                    })
                  ]),
                  _c("div", { staticClass: "temp-chart-box" }, [
                    _c("div", { staticClass: "chart-title" }, [_vm._v("水温")]),
                    _c("div", {
                      staticClass: "temp-chart-canvas",
                      attrs: { id: "temp-chart-box" + index }
                    })
                  ])
                ])
              ])
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "swiper-pointer-box" },
            _vm._l(_vm.pondList, function(pondInfo, index) {
              return _c("div", {
                key: pondInfo.poolId,
                class: { "pointer-item": true, on: index == _vm.pondTabIndex }
              })
            }),
            0
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "page-footer" }, [
      _c("div", { staticClass: "log-box" }, [
        _c("img", {
          attrs: { src: _vm.ossHost + "img/weixin_qrcode.png", alt: "" }
        }),
        _c("div", [_vm._v("请使用微信扫码了解更多")])
      ]),
      _c("div", { staticClass: "code-box" }, [
        _c("img", {
          attrs: { src: _vm.ossHost + "img/big_screen_logo.png", alt: "" }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-title" }, [
      _c("div", [_vm._v("区域")]),
      _c("div", [_vm._v("概况")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-item-chart" }, [
      _c("div", { attrs: { id: "canvas-count-box" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-title" }, [
      _c("div", [_vm._v("塘口")]),
      _c("div", [_vm._v("情况")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }